import { render, staticRenderFns } from "./KPIForm.vue?vue&type=template&id=2d5dd090&scoped=true"
import script from "./KPIForm.vue?vue&type=script&lang=js"
export * from "./KPIForm.vue?vue&type=script&lang=js"
import style0 from "./KPIForm.vue?vue&type=style&index=0&id=2d5dd090&prod&lang=css"
import style1 from "./KPIForm.vue?vue&type=style&index=1&id=2d5dd090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5dd090",
  null
  
)

export default component.exports